<template>
  <table class="w-100 table table-bordered evaluation-table">
    <tr>
      <th>{{ $t('scale') }}</th>
      <th v-html="t('requirements')[0]"/>
      <th>{{ t('criteria')[0] }}</th>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="4" /></td>
      <td v-html="t('requirements')[1]"/>
      <td>{{ t('criteria')[1] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="3" /></td>
      <td v-html="t('requirements')[2]"/>
      <td rowspan="2" v-html="t('criteria')[2]"/>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="2" /></td>
      <td v-html="t('requirements')[3]"/>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="1" /></td>
      <td v-html="t('requirements')[4]"/>
      <td rowspan="2">{{ t('criteria')[3] }}</td>
    </tr>
    <tr>
      <td class="text-center"><EvaluationBadge value="0" /></td>
      <td v-html="t('requirements')[5]"/>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'RequirementsTable',

  methods: {
    t (key) {
      return this.$i18n.t('components.evaluations.requirements.' + key)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/evaluations/RequirementsTable.vue